/* jshint esnext: true */
import { $html, isMobile, isIE } from './utils/environment';
import TransitionManager from './transitions/TransitionManager';

export default function(firstBlood) {
    svg4everybody();

    if (firstBlood) {
        const transitionManager = new TransitionManager();
    }

    if (isMobile) {
        $html.addClass('is-mobile');
    }

    if (isIE) {
       $html.addClass('is-ie');
    }

    jQuery.easing.def = "easeInOutCubic";
}
